import React from 'react';
import ReactDOM from 'react-dom';
import { injectGlobal } from 'styled-components'
// import './assets/index.css';
import { Provider } from 'react-redux'
import store from './store'
import registerServiceWorker from './registerServiceWorker';
import App from './App'
import 'antd/dist/antd.css';

ReactDOM.render(
    <Provider store = {store}>
        <App/>
    </Provider>
    , document.getElementById('root'));
registerServiceWorker();
injectGlobal`
    @import url('https://fonts.googleapis.com/css?family=Roboto');
    @import url('https://fonts.googleapis.com/earlyaccess/notosanstc.css');
    * {
        box-sizing: border-box;
    }
    button {
        outline: 0;
    }
    svg {
        font-family: 'PingFangTC', 'Noto Sans TC', '微軟正黑體', 'Microsoft YaHei', Roboto, Helvetica Neue, Helvetica, Arial, sans-serif;
    }
    :root {
        font-family: 'PingFangTC', 'Noto Sans TC', '微軟正黑體', 'Microsoft YaHei', Roboto, Helvetica Neue, Helvetica, Arial, sans-serif;
    }
    html {
        height: 100%;
        font-size: 20px;
        font-style: normal;
        font-stretch: normal;
    }
    body {
        overflow-x: hidden;
        margin: 0;
        padding: 0;
        color: #666666;
    }
    .fade-enter {
        height: 0px !important;
        opacity: 0.01;
    }

    .fade-enter-active {
        height: 40px !important;
        opacity: 1;
        transition: all .2s ease-in;
    }

    .fade-exit {
        height: 40px !important;
        opacity: 1;
    }

    .fade-exit-active {
        height: 0px !important; 
        opacity: 0.01;
        transition: all .2s ease-in;
    }
}

`
//- //                       _oo0oo_
//- //                      o8888888o
//- //                      88" . "88
//- //                      (| -_- |)
//- //                      0\  =  /0
//- //                    ___/`---'\___
//- //                  .' \\|     |// '.
//- //                 / \\|||  :  |||// \
//- //                / _||||| -:- |||||- \
//- //               |   | \\\  -  /// |   |
//- //               | \_|  ''\---/''  |_/ |
//- //               \  .-\__  '-'  ___/-. /
//- //             ___'. .'  /--.--\  `. .'___
//- //          ."" '<  `.___\_<|>_/___.' >' "".
//- //         | | :  `- \`.;`\ _ /`;.`/ - ` : | |
//- //         \  \ `_.   \_ __\ /__ _/   .-` /  /
//- //     =====`-.____`.___ \_____/___.-`___.-'=====
//- //                       `=---='
//- //
//- //               大佛保佑我CAPSULE永無BUG
//- //     ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


// WEBPACK FOOTER //
// ./src/index.js